import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { EtapaProyectoBean } from 'src/app/shared/model/incidencias/etapaproyecto.model';
import { Incidencias } from 'src/app/shared/model/incidencias/incidencia.model';
import { IncidenciasService } from '../incidencias.service';
import { VersionBean } from 'src/app/shared/model/incidencias/version.model';
import { ReporteIncidencia } from 'src/app/shared/model/incidencias/reporteIncidencia.model';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SoloNumeroEnteroDirective } from '../../utilerias/directives/solo-numero-entero.directive';
import { NgChartsModule } from 'ng2-charts';
import { idVigente, OpcionVersion, opcionesDeVersion } from '../resolucion-version.util';

@Component({
  selector: 'app-report-incidencia',
  standalone: true,
  templateUrl: './report-incidencia.component.html',
  styleUrls: ['./report-incidencia.component.css'],
  imports: [
    NgIf,
    NgFor,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    SoloNumeroEnteroDirective,
    NgChartsModule,
  ],
})
export class ReportIncidenciaComponent implements OnInit {
  data: FormGroup;
  selectedVersion: string;
  beanversion = new EtapaProyectoBean();
  listaversion: Array<VersionBean> = [];
  /** De la más nueva a la más vieja, con «· Vigente / · Cerrada»; el reporte abre en la vigente. */
  opcionesVersion: OpcionVersion[] = [];
  version = new VersionBean();
  formRegistro: FormGroup;

  reporteIncidencia: ReporteIncidencia[] = [];
  incidencias: Incidencias[] = [];
  totalDefectos = 0;

  numeroAprobados = 0;
  numeroDefectuosos = 0;
  numeroPendientes = 0;
  totalCiclo = 0;

  porcentajeAprobados = 0;
  porcentajeDefectuosos = 0;
  porcentajePendientes = 0;
  proyectoNombre = '';
  etapaNombre = '';

  public barChartOptions: any = {
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
      },
    },
  };

  public barChartLabels: string[] = ['Ciclo de prueba'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData: any[] = [];

  constructor(
    private incidenciasService: IncidenciasService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.formr();

    const state = history.state;
    const proyecto = state?.proyecto;
    const idEtapa = state?.idEtapa;

    if (!proyecto || !idEtapa) {
      this.regresar();
      return;
    }

    this.proyectoNombre = proyecto.nombre ?? '';
    this.beanversion.id_proyecto_etapa = proyecto.id;
    this.beanversion.id_etapa = idEtapa;

    const etapaSeleccionada = proyecto.etapas?.find((etapa) => etapa.id === idEtapa);
    this.etapaNombre = etapaSeleccionada?.nombre ?? '';
    this.listaversion = etapaSeleccionada?.versiones || [];
    // Antes abría en versiones[0], que es la más vieja (plan de etapas y versiones, hallazgo 5).
    this.opcionesVersion = opcionesDeVersion(etapaSeleccionada?.versiones);
    const versionInicial = idVigente(this.opcionesVersion) ?? this.opcionesVersion[0]?.id;

    if (versionInicial) {
      this.formRegistro.get('version')?.setValue(versionInicial);
      queueMicrotask(() => {
        this.capturarversion(versionInicial);
        this.cdr.detectChanges();
      });
    }
  }

  formr() {
    this.formRegistro = this.formBuilder.group({
      cAprobados: [''],
      cdefetuosos: [''],
      cpendientes: [''],
      ctotal: [''],
      version: [''],
    });
  }

  capturarversion(id: number | string) {
    if (!id) {
      this.resetReportData();
      return;
    }

    this.version.id = id;
    this.resetReportData();

    this.incidenciasService.consultaReporte(this.version).subscribe((res) => {
      res.list.forEach((element) => {
        this.totalDefectos += element.contador;
      });
      this.reporteIncidencia = res.list;
      this.cdr.detectChanges();
    });

    this.incidenciasService.consultaCincoIncidencia(this.version).subscribe((res) => {
      this.incidencias = res.list;
      this.cdr.detectChanges();
    });
  }

  onCloseClick() {
    this.regresar();
  }

  regresar() {
    this.router.navigate(['/INCIDENCIAS/INC_QA']);
  }

  sumarCiclo() {
    const aprobados = Number(this.formRegistro.get('cAprobados')?.value || 0);
    const defectos = Number(this.formRegistro.get('cdefetuosos')?.value || 0);
    const pendientes = Number(this.formRegistro.get('cpendientes')?.value || 0);

    const total = aprobados + defectos + pendientes;
    this.formRegistro.get('ctotal')?.setValue(total);

    this.numeroAprobados = aprobados;
    this.numeroDefectuosos = defectos;
    this.numeroPendientes = pendientes;
    this.totalCiclo = total;

    if (total > 0) {
      this.porcentajeAprobados = aprobados / total;
      this.porcentajeDefectuosos = defectos / total;
      this.porcentajePendientes = pendientes / total;
    } else {
      this.porcentajeAprobados = 0;
      this.porcentajeDefectuosos = 0;
      this.porcentajePendientes = 0;
    }

    this.barChartData = [
      { data: [aprobados], label: 'Aprobados', backgroundColor: 'rgba(37, 99, 235, 0.85)' },
      { data: [defectos], label: 'Defectos', backgroundColor: 'rgba(183, 28, 28, 0.85)' },
      { data: [pendientes], label: 'Pendientes', backgroundColor: 'rgba(245, 158, 11, 0.85)' },
      { data: [total], label: 'Total', backgroundColor: 'rgba(15, 23, 42, 0.75)' },
    ];

    this.cdr.detectChanges();
  }

  private resetReportData() {
    this.reporteIncidencia = [];
    this.incidencias = [];
    this.totalDefectos = 0;
    this.cdr.detectChanges();
  }
}
